import { Box, BoxProps } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { useAnalyticsLogger } from '../../imports/ui/amplitude/helpers';
import { PostingExperience, usePostingExperience } from '../PostingExperience';
import { FeedCTA } from './FeedCTA';

export const CreatePostButton: React.FC<
  {
    group?: { _id: string; name: string };
    showFixedGroupName?: boolean;
    organization?: { _id: string; name: string };
  } & BoxProps
> = ({ group, showFixedGroupName, organization, ...boxProps }) => {
  const analyticsClient = useAnalyticsLogger();
  const router = useRouter();

  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const postingExperience = usePostingExperience({
    modal: {
      isOpen: modalIsOpen,
      onClose: () => setModalIsOpen(false),
      onOpen: () => setModalIsOpen(true),
    },
  });

  React.useEffect(() => {
    if (router.isReady) {
      if (router.query.postModalOpen) {
        analyticsClient.logEvent_comm_click_message();
        const { postModalOpen, ...rest } = router.query;
        router.replace({
          pathname: router.pathname,
          query: rest,
        });
        setModalIsOpen(true);
      }
    }
  }, [analyticsClient, router]);

  return (
    <Box {...boxProps}>
      <PostingExperience
        {...postingExperience}
        options={{
          group: group,
          showFixedGroupName: showFixedGroupName,
          organization: organization,
        }}
      />

      <FeedCTA
        onClickPost={() => {
          analyticsClient.logEvent_comm_click_message();
          postingExperience.createPost();
        }}
        onClickArticle={() => {
          analyticsClient.logEvent_comm_click_article();
          postingExperience.createArticle();
        }}
        onClickPoll={() => {
          analyticsClient.logEvent_comm_click_poll();
          postingExperience.createPoll();
        }}
        onClickQuestion={() => {
          analyticsClient.logEvent_comm_click_question();
          postingExperience.createQuestion();
        }}
      />
    </Box>
  );
};
